import { ScanResultType } from "~/features/scanDmc/types/ScanDMC";
import { Trans, useTranslation } from "react-i18next";
import { type AlertColor, AlertTitle, Link, styled } from "~/common/mui";
import { Alert } from "~/common/mui/Alert/Alert";

interface ScanResultAlertProps {
  className?: string;
  scanResult: ScanResultType;
  openOverlay?: () => void;
}

const ScanResultAlert = ({ scanResult, openOverlay, className }: ScanResultAlertProps) => {
  const { t } = useTranslation();

  let titleKey;
  let messageKey;
  let variant: AlertColor;
  switch (scanResult) {
    case ScanResultType.Success: {
      titleKey = "feature.scandmc.result.success.title";
      messageKey = "feature.scandmc.result.success.message";
      variant = "success";
      break;
    }
    case ScanResultType.Suspicious: {
      titleKey = "feature.scandmc.result.suspicious.title";
      messageKey = "feature.scandmc.result.suspicious.message";
      variant = "warning";
      break;
    }
    case ScanResultType.AlreadyScanned: {
      titleKey = null;
      messageKey = "feature.scandmc.result.alreadyScanned.message";
      variant = "info";
      break;
    }
    case ScanResultType.Counterfeit: {
      titleKey = "feature.scandmc.result.counterfeit.title";
      messageKey = "feature.scandmc.result.counterfeit.message";
      variant = "error";
      break;
    }
    case ScanResultType.UnknownCode: {
      titleKey = "feature.scandmc.result.unknownCode.title";
      messageKey = "feature.scandmc.result.unknownCode.message";
      variant = "error";
      break;
    }
    case ScanResultType.NoCodeDetected:
    default: {
      titleKey = "feature.scandmc.result.noCodeDetected.title";
      messageKey = "feature.scandmc.result.noCodeDetected.message";
      variant = "error";
      break;
    }
  }

  return (
    <Alert severity={variant} className={className}>
      {titleKey && <AlertTitle>{t(titleKey)}</AlertTitle>}
      <Trans i18nKey={messageKey} components={{ Action: <StyledLink component={"button"} onClick={openOverlay} /> }} />
    </Alert>
  );
};

const StyledLink = styled(Link)({
  display: "inline",
  color: "inherit",
  textDecoration: "underline",
  verticalAlign: "unset",
}) as typeof Link;

export default ScanResultAlert;
